import useGet from '@/core/composables/api/useGet'
import usePost from '@/core/composables/api/usePost'
import { ApiRequestStatus } from '@/core/models/api/api-request-status'
import { resolveRedirect } from '@/core/utils/resolve-redirect'
import { useInitializationStore } from '@/stores/initialization.store'
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

export const useSpecialTerms = () => {
  const router = useRouter()

  const { data, status, load } = useGet<SpecialTerms>('special-terms')
  const { status: acceptedTermsStatus, mutate: accept } = usePost('special-terms/accept')
  const initializationStore = useInitializationStore()
  const acceptTerms = async () => {
    await accept()
    if (acceptedTermsStatus.value == ApiRequestStatus.Success) {
      await initializationStore.intializeStores()
      await router.push(resolveRedirect(router.currentRoute.value.query.redirect))
    }
  }

  onMounted(() => {
    load()
  })

  return { data, status, acceptedTermsStatus, acceptTerms }
}

export interface SpecialTerms {
  readonly identifier: string
  readonly content: string
  readonly version: string
  readonly link?: string
  readonly title: string
  readonly acceptText: string
}
